import http from '../../../services/http-common';

class ExportOrderReplicateService {
    getTNAViewtable() {
    return http.get(`/TNA/db/Viewtable`);
    }

    getTNAForList() {
    return http.get(`/TNA/sp/list`);
    }
    getTNADetailForList(ExportOrderNo = 0) {
    return http.get(`/TNA/detailsp/list/${ExportOrderNo}`);
    }
    getAddTNADetailForList(ExportOrderNo = 0) {
    return http.get(`/TNA/list/add/${ExportOrderNo}`);
    }

    delete(id) {
    return http.delete(`/TNA/db/delete/${id}`);
    }

    exportOrderSummary(data) {
    return http.post(`/TNA/ExportOrderSummarySp/Summary`,data);
}


    addWithDetail(data){
        return http.post(`/TNA/dbAdd/addWithDetail`,data);

    }

    updateTNAMain(data){
        return http.put(`/TNA/db/updateTNAMain`,data);

    }
    updateWithDetail(data){
        return http.put(`/TNA/db/updateWithDetail`,data);

    }

 
   
}

export default new ExportOrderReplicateService();